// extracted by mini-css-extract-plugin
module.exports = {"quickStopButtons":"QuickStopButtons_quickStopButtons__2d_WY","quickStopButton":"QuickStopButtons_quickStopButton__3J_M6"};